class ProductCardSwatches extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('wheel', this.#onWheel, { passive: false });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('wheel', this.#onWheel);
  }

  #onClick = (e) => {
    const swatch = e.target.closest('[data-href]');
    if (swatch) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = swatch.dataset.href;
    }
  };

  #onWheel = (e) => {
    const track = this.querySelector('.swatches');
    if (!track || track.scrollWidth <= track.clientWidth) return;
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    e.preventDefault();
    track.scrollLeft += e.deltaY;
  };
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}
